export default "__VITE_ASSET__68ff0397__"